export const withErrorHandler = _ref => {
  let {
    httpClient,
    errorHandler
  } = _ref;
  const originalRequest = httpClient.request.bind(httpClient);
  const requestWithErrorHandler = async requestParams => errorHandler.withErrorHandler(() => originalRequest(requestParams), {
    errorCodesMap: {}
  }).catch(error => {
    throw errorHandler.getResolvedError(error);
  });
  httpClient.request = requestWithErrorHandler;
};
//# sourceMappingURL=withErrorHandler.js.map